export default "__VITE_ASSET__BDQb_VCh__"